import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchJobs } from '../api/common';
import ill_docs from '../images/ill-docs.png';
import icons_filter from '../images/icons-filter.png';
import Banner from '../components/Banner';
import Loader from '../components/Loader';
import AvailableJobsDefault from './common//AvailableJobTypes/AvailableJobsDefault';
import AvailableJobsBody from './common/AvailableJobsBody';
import statusColor from '../components/StatusColorHook';
import { useMediaQuery } from 'react-responsive';
import started_icon from '../images/jobicons/Blue App Started Icon.svg';
import submitted_icon from '../images/jobicons/Pink Application Submitted Icon.svg';
import offer_pending_icon from '../images/jobicons/Green Offer Pending Icon.svg';
import in_review_icon from '../images/jobicons/Red App In Review Icon.svg';
import offer_accepted_icon from '../images/jobicons/Purpler Offer Accepted Icon.svg';
import expired_icon from '../images/jobicons/Gray Application Expired Icon.svg';
import closed_icon from '../images/jobicons/Gray Application Closed Icon.svg';
import offer_decline_icon from '../images/jobicons/Red Offer Declined Icon.svg';

// eslint-disable-next-line react/prop-types
function AvailableJobs() {
  let params = useParams();
  let navigate = useNavigate();
  const handleMediaQueryChange = (matches) => {
    setIsMobile(!matches);
  };
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1050 }, undefined, handleMediaQueryChange);
  const [IsPostMobile, setIsPostMobile] = useState(params.id ? true : false);
  const [IsMobile, setIsMobile] = useState(null);
  const [loaderOpen, setLoaderOpen] = useState(true);
  const [openTab, setOpenTab] = useState(1);
  const [appData, setappData] = useState(null);
  const [bannerWarningOpen, setBannerWarningOpen] = useState(true);
  const [seletcedItem, setseletcedItem] = useState(null);
  const getData = async () => {
    const data = await fetchJobs();
    setappData(data);
    setLoaderOpen(false);
    setseletcedItem(+params.id);
  };

  const onSingleItemClick = (id) => {
    setseletcedItem(id);
    setIsPostMobile(true);
    navigate(`/available-jobs/${id}`);
  };
  const statusImage = (type) => {
    switch (type) {
      case 'started':
        return started_icon;
      case 'submitted':
        return submitted_icon;
      case 'offer pending':
        return offer_pending_icon;
      case 'in review':
        return in_review_icon;
      case 'offer accepted':
        return offer_accepted_icon;
      case 'expired':
        return expired_icon;
      case 'closed':
        return closed_icon;
      case 'offer declined':
        return offer_decline_icon;
      case 'new':
        return null;
      default:
        return null;
    }
  };
  useEffect(() => {
    getData();
    handleMediaQueryChange();
  }, []);

  return (
    <>
      <div className="grid grid-cols-12 gap-6 border-b pb-2 mb-5 border-slate-300">
        <div className="flex flex-col col-span-full xl:col-span-4 bg-white rounded-sm">
          <div className="flex flex-row">
            <h4 className="text-portal-600 text-2xl font-semibold mr-10">Available Jobs</h4>
            <img src={ill_docs} alt="laundry care icon" className=" h-10 w-auto" />
          </div>
        </div>
        <div className="flex flex-col col-span-full xl:col-span-8 bg-white  "></div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div
          className={
            'lgg:flex flex-col col-span-full lgg:col-span-4 bg-white rounded-sm ' + (IsMobile && IsPostMobile ? 'hidden' : '')
          }>
          <div>
            <div className="bg-white rounded-sm">
              <div className="flex flex-row justify-start gap-1">
                <div className="relative w-full">
                  <label htmlFor="action-search" className="sr-only">
                    Search
                  </label>
                  <input
                    id="action-search"
                    className="form-input focus:border-slate-300 w-full rounded-lg"
                    type="search"
                    placeholder="Search jobs by title of keyword"
                  />
                  <button
                    className="absolute inset-0 left-auto group  bg-portal-100 m-1 rounded-lg"
                    type="submit"
                    aria-label="Search">
                    <svg
                      className="w-4 h-4 shrink-0 fill-current text-portalother-100 group-hover:text-slate-500 ml-3 mr-2"
                      viewBox="0 0 16 16"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
                      <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
                    </svg>
                  </button>
                </div>
                <div className="relative inline-flex">
                  <button
                    className="btn bg-portal-100 text-portalother-100 py-1 px-2 rounded-lg cursor-pointer"
                    onClick={() => onSingleItemClick('filter')}
                    aria-haspopup="true">
                    <span className="sr-only">Filter</span>
                    <wbr />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2.5">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6">
                {!loaderOpen ? (
                  <div className="flex-auto">
                    {appData?.data.map((app, index) => {
                      return (
                        <div
                          className={`relative bg-portal-100 p-5 text-center rounded-lg cursor-pointer my-4${
                            seletcedItem === app.id ? ' border border-portalother-100 bg-portalother-200' : ''
                          }`}
                          key={index}
                          onClick={() => onSingleItemClick(app.id)}>
                          <h2 className="text-base font-semibold mb-1 text-indigo-900 capitalize">{app.name}</h2>
                          <p>
                            <span className="text-sm text-gray-500">Posted On:</span>{' '}
                            <span className="text-sm text-black">{app.date}</span>
                          </p>
                          {statusImage(app.status) && (
                            <img
                              className="h-10 absolute left-8 md:left-14 top-6"
                              src={statusImage(app.status)}
                              alt={app.status}
                              onerror="this.style.display='none'"
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <Loader />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={'flex-col col-span-full lgg:col-span-8 bg-white  lgg:flex ' + (IsMobile && IsPostMobile ? '' : 'hidden')}>
          {IsMobile && IsPostMobile && !isDesktopOrLaptop ? (
            <div className=" cursor-pointer" onClick={() => setIsPostMobile(false)}>
              <span className="btn-sm px-3 bg-white border-slate-200 hover:border-slate-300 text-slate-600">
                <svg className="fill-current text-slate-400 mr-2" width="7" height="12" viewBox="0 0 7 12">
                  <path d="M5.4.6 6.8 2l-4 4 4 4-1.4 1.4L0 6z" />
                </svg>
                <span>Back</span>
              </span>
            </div>
          ) : null}
          {seletcedItem ? <AvailableJobsBody /> : <AvailableJobsDefault />}
        </div>
      </div>
    </>
  );
}

export default AvailableJobs;
